<div class="content">
  <div class="home-btn">
    <button mat-raised-button class="" (click)="home()">
      Home
      <i class="fas fa-home"></i>
    </button>
  </div>
  <router-outlet></router-outlet>
</div>
